/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { WhoWeAreWrapper } from './styles'
import { Header2, Text, LinkButton } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import assetWeb from '../../../public/affiliate/ambassador_asset.jpg'
import assetMobile from '../../../public/affiliate/ambassador_asset_mobile.jpg'
import Image from 'next/image'

const WhoWeAre = () => {
  return (
    <WhoWeAreWrapper>
      <div className="who-we-are-web">
        <Header2 className='mobile-header'>Who we are</Header2>
        <div className="left">
          <Header2 margin="0 0 34px 0">Who we are</Header2>
          <div className="text-container">
            <div className='content'>
              <Text lineHeight="145%" fontSize={24} margin="0 0 24px 0">
                Since 2014, Glamsquad has eliminated bad hair days, chipped nails,
                and smokey eye fails with salon-quality glam at your doorstep.
              </Text>
              <Text lineHeight="145%" fontSize={24} margin="0 0 60px 0">
                Clients get access to our team of in-demand beauty pros
                365 days a year. That means blowouts, hair styling, makeup,
                and mani-pedis on call.* Appointments begin as early 
                as 6am and as late as 10pm—so you can get glam on your schedule.
              </Text>

              <Text>
                *Nails offered in NYC, LA, Miami, and Dallas only.
              </Text>

            </div>
            <LinkButton
              href='/how-it-works'
              outline
              large
              color={gsColors.black}
            >
              Learn more
            </LinkButton>
          </div>
        </div>
        <div className="right">
          <div className="photo-booth-image">
            <Image
              src={assetWeb}
              alt='GLAMSQUAD beauty pros and brand ambassadors delivering salon-quality glam at home'
              priority
              quality={100}
              className='image-web'
            />
            <Image
              src={assetMobile}
              alt='GLAMSQUAD beauty pros and brand ambassadors delivering salon-quality glam at home'
              priority
              quality={100}
              className='image-mobile'
            />
          </div>
        </div>
      </div>
    </WhoWeAreWrapper>
  )
}

export default WhoWeAre
